import { ScheduleEventDeviceConfig } from '@thingslog/repositories';
import { EventConfigFactory } from './EventConfigFactory';

export class SendDateOverMqttFactory implements EventConfigFactory {
  public create(deviceNumbers: string[]): ScheduleEventDeviceConfig {
    return {
      '@type': 'SEND_DATE_OVER_MQTT',
      deviceCommand: 'SEND_DATE_OVER_MQTT',
      deviceNumbers,
    };
  }
}
